'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var qwest = _interopRequireWildcard(require("qwest"));
var _Button = _interopRequireDefault(require("@material-ui/core/Button"));
var _TextInput = _interopRequireDefault(require("Components/Forms/Elements/TextInput"));
var _getErrorsFromResponse = _interopRequireDefault(require("Components/Forms/Functions/getErrorsFromResponse"));
var _getFormStatus = _interopRequireDefault(require("Components/Forms/Functions/getFormStatus"));
var _handleChange = _interopRequireDefault(require("Components/Forms/Functions/handleChange"));
var _Loader = _interopRequireDefault(require("Pure/Loader"));
var _Link = _interopRequireDefault(require("Pure/Link"));
var _Routes = require("Shared/Routes");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
let app = window.app;
const DEFAULT_ERROR = 'Connexion impossible, veuillez rententer ' + 'ultérieurement.';
class LoginForm extends _react.Component {
  state = {
    status_messages: {},
    error: undefined
  };
  handleChange = _handleChange.default.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    if (app.state.form_error) {
      component.setState({
        error: app.state.form_error
      });
    }
  }
  login = e => {
    const component = this,
      props = this.props,
      state = this.state;
    e.preventDefault();
    component.setState({
      loading: true
    });
    qwest.post('/login', {
      login: state.email,
      password: state.password
    }).then(function (xhr, response) {
      // Update user permissions now that user is connected
      app.emit({
        event: 'sessionNeedsRefresh',
        source: 'login'
      });
      if (response.user.roles.includes('admin') || response.user.roles.includes('agent') || response.user.roles.includes('accompanist')) {
        app.navigateTo((0, _Routes.URL)('AdminCandidatesDashboard', _Routes.front_urls));
      } else if (response.user.roles.includes('candidate')) {
        const link = '/mon-compte-candidat/' + response.user.id;
        app.navigateTo(link);
      } else if (response.user.roles.includes('companies-manager')) {
        app.navigateTo((0, _Routes.URL)('AdminCompaniesDashboard', _Routes.front_urls));
      } else {
        const link = '/mon-compte-entreprise/' + response.user.id;
        app.navigateTo(link);
      }
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...(0, _getErrorsFromResponse.default)({
          response: response,
          error: DEFAULT_ERROR
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = (0, _getFormStatus.default)(state);
    const loader = state.loading === true ? /*#__PURE__*/_react.default.createElement(_Loader.default, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let output = /*#__PURE__*/_react.default.createElement("form", {
      method: "POST",
      action: "/login",
      className: "login-page__form",
      onSubmit: component.login
    }, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['email'],
      name: "email",
      label: "E-mail",
      type: "email",
      autocomplete: "current-email",
      status: state.status_messages
    }), /*#__PURE__*/_react.default.createElement(_TextInput.default, {
      onChange: component.handleChange,
      value: state['password'],
      name: "password",
      label: "Mot de passe",
      type: "password",
      className: "u-margin-top-10",
      autocomplete: "current-password",
      status: state.status_messages
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-text-right u-margin-top-20"
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      color: "secondary",
      size: "small",
      href: (0, _Routes.URL)('PasswordRecovery', _Routes.front_urls),
      component: props => /*#__PURE__*/_react.default.createElement(_Link.default, props),
      status: state.status_messages
    }, "Mot de passe oubli\xE9\xA0?")), status, /*#__PURE__*/_react.default.createElement("div", {
      className: "u-full-width u-margin-top-25 u-text-center"
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "submit",
      className: "c-btn c-btn--blue",
      status: state.status_messages
    }, "Je me connecte", loader)));
    return output;
  }
}
exports.default = LoginForm;
